"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var StoreAlt = function StoreAlt(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#666666' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size,
      _ref$langContext = _ref.langContext,
      langContext = _ref$langContext === void 0 ? {} : _ref$langContext;
  var iconSize = size === 'original' ? 'width="20" height="20"' : 'width="100%"';
  var translate = langContext.translate;

  translate = translate || function (text) {
    return text;
  };

  var title = translate('Store Alt Icon');
  return "\n    <svg title=\"".concat(title, "\" ").concat(iconSize, " fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <title>").concat(title, "</title>\n        <g id=\"/fulfillment/pick-up-in-store\">\n        <g id=\"icon/fulfillment/store copy\">\n          <path id=\"color\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.00037 6.9917L11.9999 5.00269L17.0055 6.9917V7.99347H19.9926V9.00879H22.0239V18.0176H19.0228V12H4.98492V18.0176H2.01099V9.00879H4.03772V7.99347H7.00037V6.9917ZM6.01398 13.0126H18.0125V17.9927H6.01398V13.0126ZM2.00977 19.0238H22.0177V19.979H2.00977V19.0238Z\" fill=\"").concat(color, "\"/>\n        </g>\n      </g>\n    </svg>\n  ");
};

var _default = StoreAlt;
exports["default"] = _default;